module.exports = {
      id: "whatsapp-not-filled-icon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#whatsapp-not-filled-icon",
      toString: function () {
        return this.url;
      }
    }